// extracted by mini-css-extract-plugin
export var colorBase = "R0TkHvDuNw_JsPDqRSB_";
export var colorDisabled = "ghNusQskwO1fVCrOVkHQ";
export var colorInverted = "C8BIsVbBYtU4XgrwH1wV";
export var colorNegative = "WrUq_ADZssqc4Y5lyRoe";
export var colorPositive = "UvDgMgSbDgvbdNgx58EV";
export var colorSubdued = "CoJHchnvBgmc7J2bzuGK";
export var colorSubtle = "Ozf5ghvy3gQVDGQpQwK9";
export var colorUrgencyHigh = "miSgFOFzF0OwcBHnUw9w";
export var colorUrgencyMedium = "IU3zpk7W_ac3xzg8ge1a";
export var colorWarning = "ZYwqTfXN1IuwLqqKiORx";
export var colorWhite = "qoH7i8vPM8tPhtuWdSLw";